<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="比赛ID" prop="matchId")
                    div.width_label {{ruleForm.matchId}}
                el-form-item(label="比赛名称" prop="matchName")
                    div.width_label {{ruleForm.matchName}}
                el-form-item(label="比赛类别")
                    div.width_label 微赛事
                el-form-item(label="主办单位" prop="createUserInfoRealName")
                    div.width_label {{ruleForm.createUserInfoRealName}}
                el-form-item(label="比赛场地")
                    div.width_label {{ruleForm.venueAddress}}
                br
                el-form-item(label="赛事类型" prop="projectType")
                        div.width_label(v-if="ruleForm.projectType == 1") 单打
                        div.width_label(v-if="ruleForm.projectType == 2") 双打
                        //- div.width_label(v-if="ruleForm.ctType === 4") 年度总决赛
                el-form-item(label="签位" prop="applySize")
                        div.width_label {{ruleForm.joinCount}}/{{ruleForm.applySize}} 签
                el-form-item(label="比赛时间")
                        div.width_label {{ruleForm.matchStartTime}}
                el-form-item(label="状态")
                    div.width_label(v-if="ruleForm.matchStatus == 2") {{ruleForm.statusName}}
                    div.width_label(v-if="ruleForm.matchStatus == 3") 已取消
                    div.width_label(v-if="ruleForm.matchStatus == 4") 已结束
                el-form-item(label="排序" v-if="ruleForm.projectType == 2")
                      el-select(v-model='orderform' placeholder="请选择排序标准" @change="changeOrderform" )
                        el-option(label="级别和" value=1)
                        el-option(label="积分和" value=2)
                br
                //- el-form-item(label="俱乐部名")
                //-   el-input(v-model="clubName" placeholder="请输入俱乐部名称" clearable='')
                //- el-button(@click='getEnrollData()',type='primary',icon='el-icon-search',style='float:right;margin-right:%2') 查 询
            //- el-row(style="padding-top:30px")
            //-     el-col(:span="21")
            //-         el-button(type="primary" @click="addEnrollView" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 添加队伍
            //-         el-button(type="danger" @click="delEnrollClub(2)" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 删除队伍
            //-         el-button(type="primary" @click="clickRefund(2)" :disabled="ruleForm.matchStatus==4") 退 款
            //-         el-button(type="primary" @click="exportExcel") 名单导出
                //- el-col(:span="3")
                //-     el-button(type="primary" @click='openSortFormatr') 调整赛制
                //-     el-button(type="primary" @click='openSortNumber') 调整排序号
            el-row(style="padding-top:10px")
                el-col(:span="24")
                   el-card(shadow="never")
                      div(slot="header" class="headTitle")
                        div
                            font.font_label 参赛人员
                        //- div
                        //-     el-button(type="primary" @click='openSortFormatr') 调整赛制
                        //-     el-button(type="primary" @click='openSortNumber') 调整排序号
                      div
                        el-table(:data="enrollData" border @selection-change="enrollDataChangeEve")
                            el-table-column(type="selection" align='center' width='40')
                            el-table-column(type="index" align='center' label="序号" width='80')
                            el-table-column(prop="name" label="姓名" align='center')
                            el-table-column(prop="mobile" label="手机号" align='center' width="130")
                            el-table-column(prop="gender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="age" label="年龄" align='center' )
                            el-table-column(prop="level" label="级别" align='center')
                            el-table-column(prop="score" label="积分" align='center' )
                            el-table-column(prop="signNo" label="签位号" align='center' )
                            el-table-column(prop="matchSignTime" label="报名时间" align='center' width='130' )
                            el-table-column(prop="teammateName" label="队友姓名" align='center')
                            el-table-column(prop="teammateMobile" label="队友手机号" align='center' width='130')
                            el-table-column(prop="teammateGender" label="队友性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.teammateGender === 0") 男
                                    font(v-if="scope.row.teammateGender === 1") 女
                            el-table-column(prop="teammateAge" label="队友年龄" align='center')
                            el-table-column(prop="teammateLevel" label="队友级别" align='center')
                            el-table-column(prop="teammateScore" label="队友积分" align='center')
                        el-row(style="padding-top:10px")
                          el-col(:span="24")
                              el-card(shadow="never")
                                  div(slot="header")
                                      font.font_label 对阵表
                                  div
                                      //- 二期改造内容,暂时先屏蔽
                                      div(class="marginBottom")
                                          el-button(@click="chooseRound(item)" v-for='(item,index) in roundList' :type="primary===item?'primary':''") {{item}}R
                                      el-table(:data="matchTableData" border :span-method="objectSpanMethod")
                                        el-table-column(prop="matchTime" label="比赛时间" align="center")
                                        el-table-column(prop="signNum" label="签位号" align="center")
                                        el-table-column(prop="name" label="姓名" align="center")
                                        //- el-table-column(prop="name" :label="choseNumber==1?'第一双打': choseNumber==2 ? '第二双打': choseNumber==3 ? '第三双打' : '' " align="center")
                                        el-table-column(prop="memberAccount" label="手机号" align="center")
                                        el-table-column(prop="sex" label="性别" align="center")
                                          //- template(slot-scope="scope")
                                          //-     font(v-if="scope.row.playerList.sex === 0") 男
                                          //-     font(v-if="scope.row.playerList.sex === 1") 女
                                        el-table-column(prop="age" label="年龄" align="center")
                                        //- el-table-column(prop="level" label="级别" align="center")
                                        el-table-column(prop="totalScore" label="积分" align="center")
                                        //- el-table-column(prop="memberType" label="会员类型" align="center")
                                          //- template(slot-scope="scope")
                                          //-         font(v-if="scope.row.memberType == 1") 注册会员
                                          //-         font(v-if="scope.row.memberType == 2") 初始会员
                                          //-         font(v-if="scope.row.memberType == 3") 荣誉会员
                                        //- el-table-column(prop="yieldScore" label="让分" align="center")
            //- enroll-club-add(v-if='enrollClubAddVisiable', ref="enrollClubAdd", @refreshDataList='init')
            //- //查看队员
            //- enroll-club-member-view(v-if='enrollClubMemberViewVisiable', ref="enrollClubMemberView")
            //- //添加队员
            //- enroll-club-member-add(v-if='enrollClubMemberAddVisiable', ref="enrollClubMemberAdd")
            //- //删除队员
            //- enroll-club-member-delete(v-if='enrollClubMemberDeleteVisiable', ref="enrollClubMemberDelete", @refreshDataList='init')
            //- //添加第六人
            //- enroll-sixman-add(v-if='enrollSixmanAddVisiable', ref="enrollSixmanAdd", @refreshDataList='init')

            //退款
            el-dialog(title="退款" :visible.sync='refundVisible' :append-to-body='true' :modal-append-to-body='false' :close-on-click-modal='false')
                el-form(:model="refundForm" ref="refundForm" style="padding:30px;")
                    el-row
                       el-col(:span="8")
                            div(style="float:right")
                              el-radio(v-model="radio" label="1" border) 按比例退款
                       el-col(:span="16")
                            el-form-item(prop="refundScale" label="：" style="display:inherit;")
                                el-input-number(:disabled="radio==1 ? false : true" v-model="refundForm.refundScale" :min=0 :max=100 )
                    el-row
                        el-col(:span="8")
                            div(style="float:right")
                                el-radio(v-model="radio" label="2" border) 按固定金额退款
                        el-col(:span="16")
                            el-form-item(prop="refundFee" label="：" style="display:inherit;")
                                el-input-number(:disabled="radio==2 ? false : true" v-model="refundForm.refundFee" :min=0 :max="refundFeeMax" :precision="2" )
                    //- el-row
                    //-     el-input(v-model="refoundDescr" type="textarea" :rows=6 resize="none" placeholder="add请输入退款原因")
                span.dialog-footer(slot="footer")
                    el-button(@click="comfirmRefundRee" type="primary" :disabled='refundBtn') 确 定
                    el-button(@click="refundVisible=false") 取 消
        SortNumber(v-if='SortNumberVisible', ref="SortBmber",@refreshSortFormatrList='SortFormatrList')
        SortFormat(v-if='SortFormatrVisible', ref="SortFormatr",@refreshSortFormatrList='choseSortBmber')
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返回
</template>
<script>
import table from './table.js'
import enrollClubAdd from './enroll-club-add'
import enrollClubMemberView from './enroll-club-member-view'
import enrollClubMemberAdd from './enroll-club-member-add'
import enrollClubMemberDelete from './enroll-club-member-delete'
import enrollSixmanAdd from './enroll-sixman-add'
import SortNumber from './SortNumber'
import SortFormat from './SortFormat'
export default {
	components: {
		enrollClubAdd,
		enrollClubMemberView,
		enrollClubMemberAdd,
		enrollClubMemberDelete,
		enrollSixmanAdd,
		SortNumber,
		SortFormat
	},
	data () {
		return {
			isRoundView: true,
			choseNumber: 1,
			chooseclublevelNumber: 1,
			primary: 1,
			canAddOrdel: false,
			isCollapse: true,
			table: {
				columns: table.columns,
				data: null,
				size: 'mini',
				stripe: true,
				border: true
			},
			SortFormatrVisible: false,
			SortNumberVisible: false,
			enrollClubAddVisiable: false, //添加队伍弹窗
			enrollClubMemberViewVisiable: false, //查看队员弹窗
			enrollClubMemberAddVisiable: false, //添加队员
			enrollClubMemberDeleteVisiable: false, //删除队员
			enrollSixmanAddVisiable: false, //添加第六人
			addOrViewArgue: true,
			refundBtn: false, //退款按钮禁用
			argueTitle: '',
			argueForm: {
				argue: ''
			},
			refundList: [],
			memberMobile: '',
			buttonSize: 'large',
			options: [],
			value: '',
			clubName: '',
			visible: false,
			refundVisible: false,
			title: '参赛人员管理',
			enrollData: [],
			enrollDataChange: [],
			enrollOrderList: [], //所有的参赛人员
			item: {},
			orderform: '1', // 1-按级别和-积分和，2-按级别差-积分和
			ruleForm: {
				id: '',
				ctId: '',
				matchName: '',
				orgId: '',
				city: '',
				province: '',
				placeId: '',
				ctType: '',
				applySize: '',
				projectType: null,
				level: '',
				bench: '0',
				applyDate: [],
				matchSignStartTime: '',
				matchSignEndTime: '',
				matchStartTime: '',
				imgList: '',
				gameDescription: '',
				matchDescription: '',
				imgDetailList: '',
				repeatSign: '0',
				genderLimit: '2',
				ageLimit: '',
				ageMinMen: undefined,
				ageMaxMen: undefined,
				ageMinWomen: undefined,
				ageMaxWomen: undefined,

				scoreMin: '',
				ctRefundList: [],
				byx1: '',
				verifyReason: '',
				orderForm: 1,
				enrollDisabled: false
			},
			payRefund: null,
			refundForm: {
				refundScale: undefined,
				refundFee: undefined
			},
			radio: undefined,
			loading: null,
			refundFeeMax: 0,
			roundList: [],
			clublevel: [],
			refoundDescr: '', // 退款说明
			matchTableData: [] // 对阵表数据
		}
	},
	methods: {
		// 获取伦次
		Round () {
			return new Promise((resolve, reject) => {
				console.log(this.ruleForm)
				let params = {
					ctId: this.ruleForm.id
				}
				this.$http({
					url: this.$http.adornUrl(
						`/ctCompetition/operation/player-manage/against-list/micro/rounds/`
					),
					method: 'POST',
					params: params,
				}).then((data) => {
					if (data && data.code === 0) {
						// this.matchTableData = data.data // array
						if (data.data !== null) {
							this.isRoundView = true
							this.roundList = []
							let round = data.data * 1
							for (var i = 0; i < round; i++) {
								this.roundList.push(i + 1)
							}
							this.primary = this.roundList[0]
							this.choseNumber = 1
							this.AgainstPlan()
						} else {
							this.roundList = []
							this.isRoundView = false
							this.matchTableData = []
						}
					}
				})
			})
		},
		Round1 () {
			return new Promise((resolve, reject) => {
				/* 你的逻辑代码 */
				this.$http({
					url: this.$http.adornUrl(
						`/weChat/referee/getCtRound/${
							this.ruleForm.id
						}`
					),
					method: 'get'
				}).then((data) => {
					if (data && data.code === 0) {
						this.clublevel = data.rounds
						this.chooseclublevelNumber =
							data.rounds[0].key
						this.AgainstPlan()
					} else {
						this.clublevel = []
						this.chooseclublevelNumber = ''
					}
				})
			})
		},
		// 获取对阵表
		AgainstPlan () {

			this.matchTableData = []
			if (
				this.primary != ''
			) {
				this.$http({
					url: this.$http.adornUrl(
						`/ctCompetition/operation/player-manage/against-list/micro/`
					),
					method: 'POST',
					params: {
						round: this.primary,
						ctId: this.ruleForm.id
					}
				}).then((data) => {
					if (data && data.code === 0) {
						this.matchTableData = []
						let arr = data.data.infoList
						arr.map(info => {
							info.playerList.map(player => {
								player.matchTime = info.microMatchTime
								this.matchTableData.push(player)
							})
						})
					} else {
						this.matchTableData = []
					}
				})
			}
			// })
		},
		// 成绩管理录入数据查看事件
		chooseRound (type) {
			this.primary = type

			this.AgainstPlan()
		},
		// 选择第几双打
		choosedoubles (val) {
			this.choseNumber = val
			this.AgainstPlan()
		},
		chooseclublevel (val) {
			this.chooseclublevelNumber = val
			this.AgainstPlan()
		},
		// 调整序列号
		openSortNumber () {
			this.SortNumberVisible = true
			this.$nextTick(() => {
				this.$refs.SortBmber.init(
					this.enrollDataOne,
					this.ruleForm.id,
					this.ruleForm.projectType
				)
			})
		},
		// 调整赛制
		openSortFormatr () {
			this.SortFormatrVisible = true
			this.$nextTick(() => {
				this.$refs.SortFormatr.init(this.ruleForm.id)
			})
		},
		choseSortBmber () {
			this.init(this.ruleForm.id)
			this.SortNumberVisible = false
		},
		SortFormatrList () {
			this.init(this.ruleForm.id)
		},
		openFullScreen () {
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})
		},
		init (item) {
			console.log(item)
			if (item) {
				this.item = item
				this.ruleForm.id = item.id
			}
			this.choseNumberb = ''
			this.chooseclublevelNumber = ''
			this.primary = ''
			this.radio = undefined
			this.visible = true
			this.enrollData = []
			this.enrollDataChange = []
			//回选
			this.$http({
				url: this.$http.adornUrl(
					`/ctCompetition/getId/` + this.ruleForm.id
				),
				method: 'get'
			})
				.then((data) => {
					if (data && data.code === 0) {
						this.ruleForm = data.bean
						//console.log(this.ruleForm, '竞赛信息')
						let joinCount = this.ruleForm.joinCount //已报名参赛人员的人数
						let applySize = this.ruleForm.applySize //赛事签位数
						let date1 = new Date().getTime()
						let date2 = new Date(
							this.ruleForm.matchStartTime
						).getTime()
						let date3 = new Date(
							this.ruleForm.matchSignStartTime
						).getTime()
						let date4 = new Date(
							this.ruleForm.matchSignEndTime
						).getTime()
						// this.ruleForm.enrollDisabled = true
						if (date1 < date3) {
							this.ruleForm.statusName = '未开始'
							// this.ruleForm.enrollDisabled = false
						} else if (
							date1 >= date3 &&
							date1 <= date4 &&
							joinCount < applySize
						) {
							this.ruleForm.statusName = '报名中'
							// this.ruleForm.enrollDisabled = false
						} else if (
							date1 >= date3 &&
							date1 <= date4 &&
							joinCount >= applySize
						) {
							this.ruleForm.statusName = '已报满'
							// this.ruleForm.enrollDisabled = false
						} else if (date1 > date4 && date1 < date2) {
							this.ruleForm.statusName = '报名结束'
							// this.ruleForm.enrollDisabled = false
						} else if (date1 >= date2) {
							this.ruleForm.statusName = '已开赛'
							// this.ruleForm.enrollDisabled = true
						}
						//报名结束后 比赛开始前可添加删除人员

						// if(date4<date1&&date1<date2){
						//     this.canAddOrdel = false
						// }else{
						//     this.canAddOrdel = true
						// }
					}
				})
				.then(() => {
					this.getEnrollData()
					// 获取对阵表数据
					// this.getMatchTableData(id)
				})
			this.Round()
			this.Round1()
			this.$nextTick(() => {
				this.AgainstPlan()
			})
		},
		// 参赛人员管理-对阵表信息
		// getMatchTableData (id) {
		//   this.$http({
		//     url: this.$http.adornUrl(
		//       `/ctCompetition/operation/player-manage/against-list/${id}`
		//     ),
		//     method: 'get'
		//   }).then((data) => {
		//     if (data && data.data.code === 0) {
		//       this.matchTableData = data.data
		//     }
		//   })
		// },
		changeOrderform (value) {
			this.orderform = value
			this.getEnrollData()
		},
		//列表刷新
		getEnrollData () {
			let params = {
				ctId: this.ruleForm.id,
				projectType: this.item.projectType,
				orderform: this.orderform
			}
			this.$http({
				url: this.$http.adornUrl(
					`/elEnroll/microEnrollListByCtId/`
				),
				method: 'post',
				params: this.$http.adornParams(params)
			}).then((data) => {
				if (data && data.code === 0) {
					//console.log(data)
					this.enrollData = data.info
					// this.enrollOrderList = data.eoList
					this.table.data = data.info
					// for (let i of this.enrollData) {
					// 	if (
					// 		i.refundScale === null &&
					// 		i.refundFee !== null
					// 	) {
					// 		i.refundScale = (
					// 			(i.orderFee / i.refundFee) *
					// 			100
					// 		).toFixed(2)
					// 	}
					// 	if (
					// 		i.refundFee === null &&
					// 		i.refundScale !== null
					// 	) {
					// 		i.refundFee = (
					// 			(i.orderFee * i.refundScale) /
					// 			100
					// 		).toFixed(2)
					// 	}
					// }
				}
			})
		},
		//添加参赛队伍页面
		addEnrollView () {
			this.enrollClubAddVisiable = true
			this.$nextTick(() => {
				this.$refs.enrollClubAdd.init(
					this.ruleForm,
					this.enrollData
				)
			})
		},

		//查看队员
		viewMemberList (row) {
			this.enrollClubMemberViewVisiable = true
			this.$nextTick(() => {
				this.$refs.enrollClubMemberView.init(row)
			})
		},
		//添加队员弹窗
		addEnrollMember (row) {
			this.enrollClubMemberAddVisiable = true
			this.$nextTick(() => {
				this.$refs.enrollClubMemberAdd.init(row, this.ruleForm)
			})
		},
		//删除队员弹窗
		deleteEnrollMember (row) {
			this.enrollClubMemberDeleteVisiable = true
			this.$nextTick(() => {
				this.$refs.enrollClubMemberDelete.init(
					row,
					this.ruleForm
				)
			})
		},
		//添加第六人
		addSixMan (row) {
			this.enrollSixmanAddVisiable = true
			//console.log('this.$refs.enrollSixmanAdd', this.$refs.enrollSixmanAdd)
			this.$nextTick(() => {
				this.$refs.enrollSixmanAdd.init(row, this.ruleForm)
			})
		},
		//删除队伍
		delEnrollClub (btn, row) {
			let idArr = []
			if (btn === 1) {
				//单个删除
				if (
					row.payStatus === 2 ||
					row.payStatus === 5 ||
					row.payStatus === 6 ||
					row.payStatus === 8 ||
					row.payStatus === 10
				) {
					this.$message.error('提示：请先进行退费操作!')
					return
				}
				idArr.push(row.id)
			} else {
				//批量删除
				if (this.enrollDataChange.length === 0) {
					this.$message.error('提示：请勾选要删除的队伍！')
					return
				}
				//console.log(this.enrollDataChange, '要删除的队伍')
				for (let i of this.enrollDataChange) {
					//console.log('遍历要删除的队伍', i)
					if (
						i.payStatus === 2 ||
						i.payStatus === 5 ||
						i.payStatus === 6 ||
						i.payStatus === 8 ||
						i.payStatus === 10
					) {
						this.$message.error(
							'提示：请先进行退费操作!'
						)
						return
					}
					idArr.push(i.id)
				}
			}
			//console.log('要删除的参赛队伍：', idArr.toString())
			this.$confirm('是否删除该队伍', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					this.$http({
						url: this.$http.adornUrl(
							`/elEnroll/deleteByEnroll`
						),
						method: 'post',
						params: this.$http.adornParams({
							ids: idArr.join()
						})
					}).then((data) => {
						if (data && data.code === 0) {
							if (data.state) {
								this.$message.success(
									'删除成功'
								)
								this.init()
							} else {
								this.$message.error(data.info)
							}
						}
					})
				})
				.catch(() => {
					this.$message.info('已取消')
				})
		},
		//退款事件
		clickRefund (btn, row) {
			//console.log('退款按钮：', row)
			this.radio = undefined
			this.payRefund = {}
			//支付状态(-1全部，0未支付,1支付中,2支付成功,3支付失败,4超时,5申请退款,6退款中,7退款成功,8退款失败,9支付已关闭，10退款已取消)
			if (btn === 1) {
				//操作栏退款
				if (
					row.payStatus === 0 ||
					row.payStatus === 1 ||
					row.payStatus === 3 ||
					row.payStatus === 4
				) {
					this.$message.error('提示：未缴费不能退款！')
					return
				}
				if (row.payStatus === 5) {
					this.$message.error('提示：已发起退款申请！')
					return
				}
				if (row.payStatus === 6 || row.payStatus === 8) {
					this.$message.error('提示：退款中！')
					return
				}
				if (row.payStatus === 7) {
					this.$message.error('提示：已完成退款！')
					return
				}
				this.payRefund.ids = row.id
				this.refundFeeMax = parseFloat(row.payAmount).toFixed(2)
			} else {
				//批量退款
				if (this.enrollDataChange.length === 0) {
					this.$message.error('提示：请勾选要退费的人员！')
					return
				}
				//console.log('勾选的退款人员', this.enrollDataChange)
				let feeFlag = false
				let feeInfo = ''
				let idArr = []
				this.refundFeeMax = parseFloat(
					this.enrollDataChange[0].payAmount
				).toFixed(2)
				this.enrollDataChange.forEach((row) => {
					if (
						row.payStatus === 0 ||
						row.payStatus === 1 ||
						row.payStatus === 3 ||
						row.payStatus === 4
					) {
						feeInfo = '提示：未缴费不能退款！'
						feeFlag = true
						return
					}
					if (row.payStatus === 5) {
						feeInfo = '提示：已发起退款申请！'
						feeFlag = true
						return
					}
					if (row.payStatus === 6 || row.payStatus === 8) {
						feeInfo = '提示：退款中！'
						feeFlag = true
						return
					}
					if (row.payStatus === 7) {
						feeInfo = '提示：已完成退款！'
						feeFlag = true
						return
					}
					idArr.push(row.id)
					//退款金额赋最大值
					if (
						this.refundFeeMax >
						parseFloat(row.payAmount).toFixed(2)
					) {
						this.refundFeeMax = parseFloat(
							row.payAmount
						).toFixed(2)
					}
				})
				if (feeFlag) {
					this.$message.error(feeInfo)
					return
				}
				//console.log('已选退费人员id：', idArr)
				//console.log('已选退费人员id：', idArr.toString())
				this.payRefund.ids = idArr.toString()
			}
			this.refundVisible = true
			this.refundForm.refundScale = undefined
			this.refundForm.refundFee = undefined
			this.refundFeeMax = parseFloat(this.refundFeeMax)
		},
		//退款提交事件
		comfirmRefundRee () {
			//console.log('退款信息：', this.refundForm)
			if (this.radio === undefined) {
				this.$message.error('请选择按比例或者固定金额退款!')
				return
			}
			if (this.radio === '1') {
				if (!this.refundForm.refundScale) {
					this.$message.error('请填写退款比例!')
					return
				} else {
					this.payRefund.refundScale = this.refundForm.refundScale
					this.payRefund.refundFee = undefined
					this.refundForm.refundFee = undefined
				}
			}
			if (this.radio === '2') {
				if (!this.refundForm.refundFee) {
					this.$message.error('请填写固定金额退款!')
					return
				} else {
					this.payRefund.refundFee = this.refundForm.refundFee
					this.payRefund.refundScale = undefined
					this.refundForm.refundScale = undefined
				}
			}
			//console.log('退款确定：', this.payRefund, this.radio, this.refundForm)
			this.refundBtn = true
			this.payRefund.refoundDescr = this.refoundDescr // 退款说明
			this.$http({
				url: this.$http.adornUrl(`/elEnrollOrder/refund`),
				method: 'post',
				data: this.payRefund
			}).then((data) => {
				if (data && data.code === 0) {
					this.$message.success('操作成功！')
					this.refundVisible = false
					this.refundBtn = false
					this.getEnrollData()
				}
			})
		},
		//参数队伍勾选事件
		// eslint-disable-next-line vue/no-dupe-keys
		enrollDataChangeEve (val) {
			this.enrollDataChange = val
		},

		//导出excel
		exportExcel () {
			let params = {
				ctId: this.ruleForm.id,
				clubName: this.clubName
			}
			this.$http({
				url: this.$http.adornUrl(
					`/elEnroll/getClubEnrollExportList`
				),
				method: 'post',
				params: this.$http.adornParams(params)
			}).then((data) => {
				if (data && data.code === 0) {
					//console.log(data)
					this.table.data = data.list
					if (
						this.table.data == null ||
						this.table.data.length === 0
					) {
						this.$message.info('没有要导出的数据!')
						return
					}
					let index = 1
					for (let i of this.table.data) {
						i.index = index++
						i.gender = { 0: '男', 1: '女' }[i.gender]
					}
					let title = this.ruleForm.matchName || ''
					this.$export
						.excel({
							columns: this.table.columns,
							data: this.table.data,
							title: title + '参赛人员'
						})
						.then(() => {
							this.$message.success('导出表格成功')
						})
				}
			})
		},
		// 时间转换
		getMyDate (str) {
			let oDate = new Date(str)
			let oYear = oDate.getFullYear()
			let oMonth = oDate.getMonth() + 1
			let oDay = oDate.getDate()
			let oHour = oDate.getHours()
			let oMin = oDate.getMinutes()
			let oSen = oDate.getSeconds()
			let oTime =
				oYear +
				'-' +
				this.addZero(oMonth) +
				'-' +
				this.addZero(oDay) +
				' ' +
				this.addZero(oHour) +
				':' +
				this.addZero(oMin) +
				':' +
				this.addZero(oSen)
			return oTime
		},
		addZero (num) {
			if (parseInt(num) < 10) {
				num = '0' + num
			}
			return num
		},
		objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				if (rowIndex % 2 === 0) {
					return {
						rowspan: 2,
						colspan: 1
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0
					}
				}
			}
		}
	}
}
</script>
<style>
.headTitle {
	display: flex;
	justify-content: space-between;
}
.nochoice {
	color: #606266 !important;
}
.choice {
	color: #02b90d !important;
}
.active {
	background: #02b90d !important;
	color: #fff !important;
}
.marginBottom {
	margin-bottom: 20px;
}
.width_label {
	width: 180px;
}
.opSetting {
	text-align: center;
	margin-top: 30px;
}
.spacing {
	margin-top: 10px;
}
.font_label {
	font-weight: bold;
	font-size: 18px;
}
</style>
